import React from 'react';
import BlueButton from '../../buttons/BlueButton';
import logo from '../../../pages/knowhow/logo.jpg';

class Welcome extends React.Component {


    render() {
        const {intl, onboarding_has_errored} = this.props;
        if(onboarding_has_errored.hasErrored) {
             return (
                <div className="ob_welcome">
                    <span  className="ob_message">{intl.formatMessage({ id: 'ob_welcome' })}</span>
                    <img alt="logo" className="ob_message_img padding_top_12 padding_bottom_48" src={logo} />
                    <span className="ob_subtitle">{intl.formatMessage({ id: 'ob_subtitle_error' })}</span>
                    <span className="ob_subtitle c_lipstick margin_top_12">{ onboarding_has_errored.error }</span>
                </div>
            );
        }
        return (
            <div className="ob_welcome">
                <span  className="ob_message">{intl.formatMessage({ id: 'ob_welcome' })}</span>
                <img alt="logo" className="ob_message_img padding_top_12 padding_bottom_48" src={logo} />
                <span className="ob_subtitle">{intl.formatMessage({ id: 'ob_subtitle' })}</span>
                <span className="ob_wrapmessage">{intl.formatMessage({ id: 'ob_wrapmessage' })}</span>
                <div className="flex_auto_row center">
                    <BlueButton id="ob_startbutton" onClick={this.props.onNext} />
                </div>
            </div>
        );
    }
}

export default Welcome;


// WEBPACK FOOTER //
// ./src/components/complex/onboarding/welcome.js